'use client';

import type { Video_Entry } from '@/lib/graphql-sdk';
import dynamic from 'next/dynamic';

const YouTubeBackground = dynamic(() => import('./YoutubePlayer'), {
    ssr: false,
});

export default function VideoBackground({ video }: { video: Video_Entry }) {
    return <YouTubeBackground video={video} />;
}
